import { Command } from 'commander'

import { JoinCommand } from '@/domains/document/join'
import { SplitCommand } from '@/domains/document/split'

import { BundleCommand } from './bundle'
import { FormatCommand } from './format'
import { LintCommand } from './lint'
import { MockCommand } from './mock'
import { ServeCommand } from './serve'
import { ShareCommand } from './share'
import { UpgradeCommand } from './upgrade'
import { ValidateCommand } from './validate'
import { VoidCommand } from './void'

const documentCommands = [
  BundleCommand,
  SplitCommand,
  JoinCommand,
  FormatCommand,
  MockCommand,
  ServeCommand,
  ShareCommand,
  ValidateCommand,
  VoidCommand,
  LintCommand,
  UpgradeCommand,
]

const documentDomain = new Command('document')
documentDomain.description('Manage local openapi file')
documentCommands.forEach((command) => documentDomain.addCommand(command()))
export default documentDomain
